import { scriptStepTypes } from '@xmatters/common/constants/scriptSteps';

export const OutputsByStepType = {
  [scriptStepTypes.CREATE_EVENT]: [
    {
      name: 'event.id',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_ID',
    },
    {
      name: 'event.eventId',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_EVENT_ID',
    },
    {
      name: 'event.created',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_DATE',
    },
    {
      name: 'event.priority',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_PRIORITY',
    },
    {
      name: 'event.initiator',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_INITIATOR',
    },
    {
      name: 'recipients',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_RECIPIENTS',
    },
    {
      name: 'conference.bridgeNumber',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_CONFERENCE_BRIDGE',
    },
    {
      name: 'conference.meetingLink',
      descriptionId: 'FLOW_DESIGN_CREATE_EVENT_OUTPUT_CONFERENCE_MEETING_LINK',
    },
  ],
  [scriptStepTypes.CREATE_ALERT]: [
    {
      name: 'alert.alertId',
      descriptionId: 'FLOW_DESIGN_CREATE_ALERT_OUTPUT_ALERT_ID',
    },
    {
      name: 'alert.id',
      descriptionId: 'FLOW_DESIGN_CREATE_ALERT_OUTPUT_ID',
    },
  ],
};

export const CreateAlertStepInputNames = {
  RESPONSES: 'responseOptions',
  TRIGGERS: 'triggers',
};

/**
 * This UI specific property is used to determine which integrations to POST at save time.
 * It's a hack, and should be removed with https://xmatters.atlassian.net/browse/COR-41872
 */
export const ALERT_INTEGRATION_DATA_PROP = 'uiCreateAlertIntegrationData';
